// extracted by mini-css-extract-plugin
module.exports = {"checkoutForm":"OrderDeliveryForm_checkoutForm__QI9Ux","errorMsg":"OrderDeliveryForm_errorMsg__zgxh1","btnContainer":"OrderDeliveryForm_btnContainer__u8CKk"};